import type { FunctionComponent, PropsWithChildren } from "react"

import Head from "next/head"

import { getLocaleTerritoryCode } from "@/modules/locales/getLocaleTerritoryCode"
import { useLocale } from "@/modules/locales/useLocale"

type MetaTagsProps = PropsWithChildren<{
  description?: string
  image?: string
  location?: string
  title?: string
}>

/**
 * This components will modify in the <head> of the document the meta tags.
 */
export const MetaTags: FunctionComponent<MetaTagsProps> = ({ children, description, image, location, title }) => {
  const currentLocale = useLocale()

  return (
    <Head>
      {/* Basic info */}
      {title && <title>{title}</title>}
      {description && <meta content={description} name="description" />}

      {/* Open Graph */}
      <meta content={getLocaleTerritoryCode(currentLocale, "_")} property="og:locale" />
      <meta content="JobTeaser" property="og:site_name" />
      {title && <meta content={title} property="og:name" />}
      {location && <meta content={location} property="og:location" />}
      {description && <meta content={description} property="og:description" />}
      {image && <meta content={image} property="og:image" />}

      {children}
    </Head>
  )
}
